import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useScrollToTop } from '../hooks/useScrollToTop';
import './ThankYou.css';

const ThankYou: React.FC = () => {
  const scrollToTop = useScrollToTop();
  return (
    <Container className="d-flex align-items-center justify-content-center vh-100">
      <Row className="text-center">
        <Col>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="thank-you-card"
          >
            <div className="success-icon-container">
              <motion.svg
                className="success-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                <circle cx="26" cy="26" r="25" fill="none" stroke="#10B981" strokeWidth="2"/>
                <path fill="none" stroke="#10B981" strokeWidth="3" d="M14,27.2l7.1,7.2l16.7-16.8"/>
              </motion.svg>
            </div>
            <h1 className="thank-you-title">Thank You!</h1>
            <p className="lead thank-you-subtitle">
              Your message has been successfully sent. We appreciate you contacting us.
            </p>
            <p className="thank-you-text">
              One of our team members will get back to you as soon as possible.
            </p>
            <Link to="/" className="btn btn-primary mt-4" onClick={scrollToTop}>
              Return to Homepage
            </Link>
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
};

export default ThankYou; 